import {ChatActions} from "components/ChatActions";
import { Users } from 'models/UserCollection';
import {Dashboard} from "components/Dashboard";
import {privateChatMessageHolder} from 'components/PrivateChatMessageHolder.jsx';
import openRoomAtMessage from 'react/chat/openRoomAtMessage';

class TokensManager {
	constructor(string){
		//var msg = string;
		var msg = string.replace(/^\s*\//, "");
		var regex = /^ *(?:(?!")([^ ]+)|"((?:[^\\"]|\\[\\"])*)")/;
		this.string = string;
		this.tokens = [];

		var arr;
		while((arr = msg.match(regex)) !== null)
		{
			if(arr[1] !== void 0)
			{
				// Non-space token
				this.tokens.push(arr[1]);
			}
			else
			{
				// Quoted token, needs extra processing to
				// convert escaped character back
				this.tokens.push(arr[2].replace(/\\([\\"])/g, '$1'));
			}
			msg = msg.substring(arr[0].length);
		}
		for(var i = this.tokens.length - 1; i >= 0; --i)
		{
			if(this.tokens[i].trim().length === 0)
			{
				if((i + 1) in this.tokens)
				{
					this.tokens[i + 1] = " " + this.tokens[i + 1];
					this.tokens.splice(i, 1);
				}
			}
		}
		this.command = this.get(0);
	};

	get(key){
		return this.tokens[key];
	}

	getStringAfterKey(key){
		return Array.prototype.slice.call(this.tokens, key).join(' ');
	}

	getMessage(){
		return this.getStringAfterKey(1);
	}


}
TokensManager.parseData = function(data){
	$.each(data, function(command, data){
		if(TokensManager.parseData.commands[command])
		{
			TokensManager.parseData.commands[command](data);
		}
	});
};
TokensManager.parseData.commands = {
	private_chat: function(data){
		privateChatMessageHolder.openPrivateChat(Users.update({
			username: data.username,
			id: data.id
		}));
	},
	// A mention's web push (services\chat\mentions\RoomMentions).
	chat_mention: function(data){
		return openRoomAtMessage(data.chat_room_id, data.chat_message_id);
	},
	view_tab: function(data){
		var tab = Dashboard.namedTabList[data.tab];
		if(tab)
		{
			if(!tab.hasClass('active'))
			{
				tab.trigger('activate');
			}
		}
	}
};

export {TokensManager};